export const AUTH_TOKEN = "auth-token";
export const USER_ID = "user-id";
export const LINKS_PER_PAGE = 30;



// WEBPACK FOOTER //
// ./src/constants.js